import React, { useEffect, useState } from 'react';
import { BoxDivisor } from 'components/common/Formulario';
import { AcaoOcorrencia, CustomDataProvider, Ocorrencia } from './types';
import { useDataProvider } from 'react-admin';
import { Box, Card, CardContent, Typography } from '@material-ui/core';
import { format, parseISO } from 'date-fns';

interface MessageProps {
	nome: string;
	tipo_acesso: string;
	tipo_acao: string | undefined;
	comentario: string | null;
	anexo: string | null;
	data: string;
}

const Message: React.FC<MessageProps> = ({ nome, tipo_acesso, tipo_acao, comentario, anexo, data }) => (
	<Card
		style={{
			width: '100%',
			margin: '10px',
			backgroundColor: '#E0E0E0',
			display: 'flex',
			marginTop: '2vh',
		}}
	>
		<Box width={'20%'}>
			<CardContent style={{ padding: '10px' }}>
				<Typography variant='subtitle2'>{nome}</Typography>
				<Typography variant='subtitle2'>{tipo_acesso}(a)</Typography>
			</CardContent>
		</Box>
		<Box width={'55%'}>
			<CardContent style={{ padding: '10px' }}>
				<Typography variant='subtitle2'>{tipo_acao}</Typography>
				<Typography
					style={{
						wordBreak: 'break-word',
						whiteSpace: 'normal',
						wordWrap: 'break-word',
						maxWidth: '100%',
					}}
					variant='body1'
				>
					{comentario}
				</Typography>
				{anexo && (
					<>
						Anexo:{' '}
						<a href={anexo} target='_blank' rel='noreferrer'>
							Clique aqui
						</a>
					</>
				)}
			</CardContent>
		</Box>
		<Box width={'25%'}>
			<CardContent style={{ padding: '10px', textAlign: 'right' }}>
				<Typography variant='subtitle2'>{format(parseISO(data), 'dd/MM/yyyy HH:mm')}</Typography>
			</CardContent>
		</Box>
	</Card>
);

interface ActionsHistoryProps {
	ocorrencia: Ocorrencia;
}

const ActionsHistory: React.FC<ActionsHistoryProps> = ({ ocorrencia }) => {
	const [acoesOcorrencias, setAcoesOcorrencias] = useState<AcaoOcorrencia[]>([]);

	const dataProvider: CustomDataProvider = useDataProvider();

	useEffect(() => {
		dataProvider
			.getOnePkMiddle('acao_ocorrencias/buscar_ocorrencias', { id: ocorrencia.id })
			.then((response: any) => {
				setAcoesOcorrencias(response.data);
			});
	}, []);

	return (
		<BoxDivisor titulo='Histórico de Ações' width='100%'>
			{acoesOcorrencias.map((acaoOcorrencia) => (
				<Message
					nome={acaoOcorrencia.nome_usuario}
					tipo_acesso={acaoOcorrencia.tipo_acesso}
					tipo_acao={
						{
							R: 'Registrou a Ocorrência',
							C: 'Comentou',
							F: 'Finalizou a Ocorrência',
						}[acaoOcorrencia.tipo_acao]
					}
					comentario={acaoOcorrencia.mensagem}
					anexo={acaoOcorrencia.anexo}
					data={acaoOcorrencia.data}
				/>
			))}
		</BoxDivisor>
	);
};

export default ActionsHistory;
